import React from 'react';
import {
	LaboratoryRequisitionTemplate,
	useLaboratoryRequisitionTemplatesQuery,
} from '../../../../../graphql/graphql';
import Loading from '../../../../../Components/Loading';
import Text from '../../../../../Components/Base/Text/Text';
import SelectionList from '../../../../Base/Components/SelectionList/SelectionList';

interface Props {
	workplaceId: string;
	doctorId: string;
	formId: string;
	onSelect: (item: LaboratoryRequisitionTemplate) => void;
}

const LaboratoryRequestTemplateSelection: React.FC<Props> = ({
	workplaceId,
	doctorId,
	formId,
	onSelect,
}) => {
	const { data, isLoading } = useLaboratoryRequisitionTemplatesQuery({
		where: { workplaceId, doctorId, laboratoryRequisitionId: formId },
		pagination: { take: 999 },
	});

	if (isLoading) {
		return <Loading />;
	}

	if ((data?.laboratoryRequisitionTemplates?.data?.length || 0) < 1) {
		return (
			<Text tx='component.laboratoryRequestTemplateSelection.noTemplatesFound' />
		);
	}

	return (
		<SelectionList<LaboratoryRequisitionTemplate>
			data={
				data?.laboratoryRequisitionTemplates
					?.data as LaboratoryRequisitionTemplate[]
			}
			onItemClick={onSelect}
			buttonLabel='component.laboratoryRequestTemplateSelection.selectTemplate'
		/>
	);
};
export default LaboratoryRequestTemplateSelection;
